import { Button, HelpButton, Logo, ThemeToggle, cx } from '@aulaviva/ui';
import { LogOut } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router';
import { useEsci } from '@/api/auth';
import { useManuale } from '@/manuale/ManualeProvider';
import { comuni, manuale } from '@/testi';
import { useUtenteArea } from './utente';

export interface VoceNav {
  to: string;
  testo: string;
}

/** Intestazione comune: logo, navigazione, nome, tema, Esci. */
export function Intestazione({ voci, home, etichettaRuolo }: { voci: VoceNav[]; home: string; etichettaRuolo?: string }) {
  const utente = useUtenteArea();
  const esci = useEsci();
  const navigate = useNavigate();
  const { apri } = useManuale();

  async function gestisciEsci() {
    await esci.mutateAsync().catch(() => undefined);
    navigate('/accedi', { replace: true });
  }

  const link = (v: VoceNav) => (
    <NavLink
      key={v.to}
      to={v.to}
      end={v.to === home || v.to === '/'}
      className={({ isActive }) => cx('t-label no-underline px-3 py-2 rounded-md', isActive ? 'bg-surface-sunken text-ink' : 'text-ink-muted hover:text-ink')}
    >
      {v.testo}
    </NavLink>
  );

  return (
    <>
      <a href="#contenuto" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:bg-surface focus:px-4 focus:py-2 focus:rounded-md">
        {comuni.vaiAlContenuto}
      </a>
      <header className="bg-surface border-b border-border">
        <div className="contenitore flex items-center justify-between gap-4 h-16">
          <div className="flex items-center gap-3">
            <NavLink to={home} aria-label={comuni.app} className="inline-flex no-underline">
              <Logo variant="orizzontale" height={32} className="dark:hidden" />
              <Logo variant="orizzontale-negativo" height={32} className="hidden dark:block" decorative />
            </NavLink>
            {etichettaRuolo && <span className="t-caption text-ink-muted hidden sm:inline border-l border-border pl-3">{etichettaRuolo}</span>}
          </div>
          <nav aria-label={comuni.menuPrincipale} className="hidden md:flex items-center gap-2">
            {voci.map(link)}
          </nav>
          <div className="flex items-center gap-2">
            <span className="t-body-small text-ink-muted hidden sm:inline">
              {utente.nome} {utente.cognome}
            </span>
            <HelpButton label={manuale.apri} onClick={() => apri()} />
            <ThemeToggle testoChiaro={comuni.temaChiaro} testoScuro={comuni.temaScuro} />
            <Button variant="discreet" icon={LogOut} onClick={gestisciEsci} loading={esci.isPending}>
              {comuni.esci}
            </Button>
          </div>
        </div>
        <nav aria-label={comuni.menuPrincipale} className="contenitore flex md:hidden gap-2 pb-2 overflow-x-auto">
          {voci.map(link)}
        </nav>
      </header>
    </>
  );
}
